"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionFieldValidationAlertWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var services_1 = require("@falcon/services");
;
;
/**
 * Displays failed question validation error messages as page alerts
 */
var InteractionFieldValidationAlertWidget = /** @class */ (function (_super) {
    __extends(InteractionFieldValidationAlertWidget, _super);
    function InteractionFieldValidationAlertWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.DEFAULT_TOP_MESSAGE = "Oops! Something went wrong.";
        _this.DEFAULT_BOTTOM_MESSAGE = "Please try again.";
        _this.getInteractionFieldValue = function () {
            return _this.bindFromField(_this.props.question.interactionField || "");
        };
        /**
         * Gets topmost error message of failed validations
         */
        _this.getValidationErrorMessage = function () {
            var validation = _this.props.validations[_this.props.question.name];
            if (validation && !validation.valid && validation.errors && validation.errors.length > 0) {
                return validation.errors[0];
            }
            return undefined;
        };
        /**
         * Closes all validation alert banners (including this one)
         */
        _this.handleClose = function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = true, _a));
        };
        _this.state = {
            isInteractionFieldValueChanged: false
        };
        return _this;
    }
    InteractionFieldValidationAlertWidget.prototype.componentDidMount = function () {
        this.setState({
            interactionFieldValue: this.getInteractionFieldValue()
        });
    };
    /**
     * Triggers validation when the value of interaction field changes
     */
    InteractionFieldValidationAlertWidget.prototype.componentDidUpdate = function () {
        var _this = this;
        var prevInteractionFieldValue = this.state.interactionFieldValue;
        var interactionFieldValue = this.getInteractionFieldValue();
        if (interactionFieldValue !== prevInteractionFieldValue) {
            this.setState({
                isInteractionFieldValueChanged: true,
                interactionFieldValue: interactionFieldValue
            }, function () { return _this.validateInternal(_this.state.interactionFieldValue); });
        }
    };
    /**
     * Renders alert banner with validation error message
     * if at least one of the validations has failed
     */
    InteractionFieldValidationAlertWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var hidePageValidationErrorMessage = journeyState["hidePageValidationErrorMessage"] || false;
        if (!this.state.isInteractionFieldValueChanged || this.isValid() || hidePageValidationErrorMessage) {
            return (0, jsx_runtime_1.jsx)(React.Fragment, {});
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "page-validation journey-validation-summary", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top", children: this.DEFAULT_TOP_MESSAGE }), (0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-bottom", children: this.getValidationErrorMessage() || this.DEFAULT_BOTTOM_MESSAGE })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-validation-close", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn page-validation-close-button", "aria-label": "close alert", onClick: this.handleClose }) })] }));
    };
    /**
     * Overrides unused abstract method
     */
    InteractionFieldValidationAlertWidget.prototype.renderInputField = function () {
        return null;
    };
    return InteractionFieldValidationAlertWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.InteractionFieldValidationAlertWidget = InteractionFieldValidationAlertWidget;
//# sourceMappingURL=InteractionFieldValidationAlertWidget.js.map